<ng-container *ngIf="!(this.plotdata && this.mainconfig && this.plotlayout)">
  <mat-spinner color="primary"></mat-spinner>
</ng-container>
<ng-container *ngIf="this.plotdata && this.mainconfig && this.plotlayout">
  <plotly-plot class="plotlydiv" [data]="this.plotdata" [divId]="this.divid" [debug]="true" [layout]="this.plotlayout"
    [config]="this.mainconfig" (plotlyClick)="this.reportclick($event);" [useResizeHandler]="true"
    [style]="{position: 'relative', width: '100%', height: '100%'}"></plotly-plot>
</ng-container>